import { h, FunctionComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { NativeSelectInput } from 'up-ops-web-shared-components';
import { trackFormBlur } from '~src/utils/tracking';
import { SelectInputProps } from '../types/forms';

const SelectInput: FunctionComponent<SelectInputProps> = ({
  id,
  value,
  options,
  onChangeHandler,
  isDisabled = false,
  isRequired = false,
  style = {},
  showPlaceholder = true,
  placeholder = '',
  className = '',
}) => {
  const inputRef = useRef<HTMLSelectElement>(null);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onBlurHandler = () => {
    dispatch(trackFormBlur(id));
    setIsFocused(false);
  };

  const onFocusHandler = () => {
    setIsFocused(true);
  };

  return (
    <NativeSelectInput
      innerRef={inputRef}
      value={value}
      id={id}
      className={isFocused ? `${className} focused` : className}
      name={id}
      disabled={isDisabled}
      required={isRequired}
      defaultValue={
        value?.length
          ? value
          : showPlaceholder && placeholder && value === ''
          ? placeholder
          : undefined
      }
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      onFocus={onFocusHandler}
      style={style}
      aria-live='off'
    >
      {showPlaceholder && placeholder && (
        <option selected={true} value={placeholder} disabled={true}>
          {placeholder}
        </option>
      )}
      {options &&
        options.map((option, idx) => {
          return (
            <option
              value={option.index}
              key={idx}
              selected={value === option.index}
            >
              {option.value}
            </option>
          );
        })}
    </NativeSelectInput>
  );
};

export default SelectInput;
